export default __webpack_public_path__ + "static/media/rating_web-xs@2x.1bb4c605.webp";